<template>
  <div class="broadcast-container">
    <el-card class="broadcast-card" shadow="hover">
      <!-- Tab切换 -->
      <el-tabs v-model="activeTab" type="card">
        <el-tab-pane label="点播与众筹" name="broadcast">
          <div class="tab-header">
            <el-button type="primary" @click="showAddForm = true" class="add-btn">发起点播</el-button>
          </div>
          
          <!-- 点播列表 -->
          <div class="broadcast-list">
        <el-table :data="broadcastList" style="width: 100%" border>
          <el-table-column prop="nickname" label="发起人" width="100">
            <template slot-scope="scope">
              {{ scope.row.nickname || scope.row.createUserId || '未知用户' }}
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
          <el-table-column prop="teamA" label="A队选手" min-width="120"></el-table-column>
          <el-table-column prop="teamB" label="B队选手" min-width="120"></el-table-column>
          <el-table-column prop="gameMode" label="比赛模式" width="100">
            <template slot-scope="scope">
              {{ getGameModeLabel(scope.row.gameMode) }}
            </template>
          </el-table-column>
          <el-table-column prop="matchType" label="类型" width="100">
            <template slot-scope="scope">
              {{ scope.row.matchType === 'match' ? '比赛' : '随机模式' }}
            </template>
          </el-table-column>
          <el-table-column prop="broadcastAmount" label="点播金额" width="100">
            <template slot-scope="scope">
              {{ scope.row.broadcastAmount || 0 }}元
            </template>
          </el-table-column>
          <el-table-column label="众筹" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.needCrowdfunding === 1">
                已筹: {{ scope.row.currentAmount }}元
              </div>
              <div v-else>
                无需众筹
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              {{ scope.row.status === 1 ? '进行中' : scope.row.status === 2 ? '已完成' : '待审核' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button size="small" type="primary" @click="viewBroadcast(scope.row)">查看详情</el-button>
              <el-button size="small" type="success" v-if="scope.row.needCrowdfunding === 1 && scope.row.status === 0" @click="openCrowdfundingForm(scope.row)">参与众筹</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
        </el-tab-pane>
        
        <!-- 赛事举办 Tab -->
        <el-tab-pane label="赛事举办" name="event">
          <div class="tab-header">
            <el-button type="primary" @click="showEventForm = true" class="add-btn">发起赛事</el-button>
          </div>
          
          <!-- 赛事列表 -->
          <div class="event-list">
            <el-table :data="eventList" style="width: 100%" border>
              <el-table-column prop="title" label="赛事名称" min-width="150"></el-table-column>
              <el-table-column prop="description" label="赛事描述" min-width="200"></el-table-column>
              <el-table-column prop="gameMode" label="比赛模式" width="100">
                <template slot-scope="scope">
                  {{ getGameModeLabel(scope.row.gameMode) }}
                </template>
              </el-table-column>
              <el-table-column prop="prizePool" label="奖池" width="100">
                <template slot-scope="scope">
                  {{ scope.row.prizePool || 0 }}元
                </template>
              </el-table-column>
              <el-table-column prop="registrationFee" label="报名费" width="100">
                <template slot-scope="scope">
                  {{ scope.row.registrationFee || 0 }}元
                </template>
              </el-table-column>
              <el-table-column prop="maxTeams" label="最大队伍数" width="100"></el-table-column>
              <el-table-column prop="currentTeams" label="已报名" width="80"></el-table-column>
              <el-table-column prop="startTime" label="比赛时间" width="160">
                <template slot-scope="scope">
                  {{ formatDate(scope.row.startTime) }}
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag :type="getEventStatusType(scope.row.status)">
                    {{ getEventStatusLabel(scope.row.status) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="viewEvent(scope.row)">查看详情</el-button>
                  <el-button size="small" type="success" v-if="scope.row.status === 0" @click="registerEvent(scope.row)">报名参赛</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
    
    <!-- 发起点播表单 -->
    <el-dialog title="发起点播" :visible.sync="showAddForm" width="600px">
      <el-form :model="broadcastForm" :rules="rules" ref="broadcastFormRef" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="broadcastForm.title" placeholder="请输入点播标题"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="broadcastForm.description" placeholder="请输入点播描述" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="A队选手" prop="teamA">
          <el-input v-model="broadcastForm.teamA" placeholder="请输入A队选手，多个选手用逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="B队选手" prop="teamB">
          <el-input v-model="broadcastForm.teamB" placeholder="请输入B队选手，多个选手用逗号分隔"></el-input>
        </el-form-item>
        <el-form-item label="比赛模式" prop="gameMode">
          <el-select v-model="broadcastForm.gameMode" placeholder="请选择比赛模式">
            <el-option label="1V1" value="1v1"></el-option>
            <el-option label="2V2" value="2v2"></el-option>
            <el-option label="3V3" value="3v3"></el-option>
            <el-option label="4V4" value="4v4"></el-option>
            <el-option label="5V5" value="5v5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="比赛类型" prop="matchType">
          <el-radio-group v-model="broadcastForm.matchType">
            <el-radio label="match">比赛</el-radio>
            <el-radio label="random">随机模式</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="点播金额" prop="broadcastAmount">
          <el-input-number v-model="broadcastForm.broadcastAmount" :min="0" :step="10" placeholder="请输入点播金额"></el-input-number>
        </el-form-item>
        <el-form-item label="是否需要众筹" prop="needCrowdfunding">
          <el-switch v-model="broadcastForm.needCrowdfunding" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item v-if="broadcastForm.needCrowdfunding === 1" label="目标金额" prop="targetAmount">
          <el-input-number v-model="broadcastForm.targetAmount" :min="100" :step="50" placeholder="请输入众筹目标金额"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddForm = false">取消</el-button>
        <el-button type="primary" @click="submitBroadcastForm">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 参与众筹表单 -->
    <el-dialog title="参与众筹" :visible.sync="showCrowdfundingForm" width="400px">
      <el-form :model="crowdfundingForm" :rules="crowdfundingRules" ref="crowdfundingFormRef" label-width="100px">
        <el-form-item label="点播标题">
          <el-input v-model="currentBroadcast.title" disabled v-if="currentBroadcast"></el-input>
          <el-input disabled v-else></el-input>
        </el-form-item>
        <el-form-item label="已筹金额">
          <el-input v-model="currentBroadcast.currentAmount" disabled v-if="currentBroadcast"></el-input>
          <el-input disabled v-else></el-input>
        </el-form-item>
        <el-form-item label="目标金额">
          <el-input v-model="currentBroadcast.targetAmount" disabled v-if="currentBroadcast"></el-input>
          <el-input disabled v-else></el-input>
        </el-form-item>
        <el-form-item label="众筹金额" prop="amount">
          <el-input-number v-model="crowdfundingForm.amount" :min="10" :step="10" placeholder="请输入众筹金额"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showCrowdfundingForm = false">取消</el-button>
        <el-button type="primary" @click="submitCrowdfunding">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 点播详情 -->
    <el-dialog title="点播详情" :visible.sync="showDetail" width="800px">
      <div v-if="currentBroadcast" class="broadcast-detail">
        <h3>{{ currentBroadcast.title }}</h3>
        <div class="detail-info">
          <div class="info-item">
            <span class="label">描述：</span>
            <span class="value">{{ currentBroadcast.description || '' }}</span>
          </div>
          <div class="info-item">
            <span class="label">A队选手：</span>
            <span class="value">{{ currentBroadcast.teamA }}</span>
          </div>
          <div class="info-item">
            <span class="label">B队选手：</span>
            <span class="value">{{ currentBroadcast.teamB }}</span>
          </div>
          <div class="info-item">
            <span class="label">比赛模式：</span>
            <span class="value">{{ getGameModeLabel(currentBroadcast.gameMode) }}</span>
          </div>
          <div class="info-item">
            <span class="label">发起人：</span>
            <span class="value">{{ currentBroadcast.nickname || currentBroadcast.createUserId || '未知用户' }}</span>
          </div>
          <div class="info-item">
            <span class="label">比赛类型：</span>
            <span class="value">{{ currentBroadcast.matchType === 'match' ? '比赛' : '随机模式' }}</span>
          </div>
          <div class="info-item">
            <span class="label">点播金额：</span>
            <span class="value">{{ currentBroadcast.broadcastAmount || 0 }}元</span>
          </div>
          <div class="info-item">
            <span class="label">众筹情况：</span>
            <span class="value">
              <div v-if="currentBroadcast.needCrowdfunding === 1">
                目标: {{ currentBroadcast.targetAmount }}元 | 已筹: {{ currentBroadcast.currentAmount }}元
              </div>
              <div v-else>
                无需众筹
              </div>
            </span>
          </div>
          <div class="info-item">
            <span class="label">状态：</span>
            <span class="value">{{ currentBroadcast.status === 1 ? '进行中' : currentBroadcast.status === 2 ? '已完成' : '待审核' }}</span>
          </div>
        </div>
        
        <!-- 众筹记录 -->
        <div v-if="currentBroadcast.needCrowdfunding === 1" class="crowdfunding-records">
          <h4>众筹记录</h4>
          <el-table :data="crowdfundingRecords" style="width: 100%" size="small" border>
            <el-table-column prop="nickname" label="用户" width="150">
              <template slot-scope="scope">
                {{ scope.row.nickname || scope.row.userId || '未知用户' }}
              </template>
            </el-table-column>
            <el-table-column prop="amount" label="金额" width="100"></el-table-column>
            <el-table-column prop="createTime" label="时间" width="180">
              <template slot-scope="scope">
                {{ formatDate(scope.row.createTime) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 视频播放区域 -->
        <div v-if="currentBroadcast.videoUrl" class="video-player">
          <h4>视频播放</h4>
          <video width="100%" controls>
            <source :src="currentBroadcast.videoUrl" type="video/mp4">
            您的浏览器不支持HTML5视频播放
          </video>
        </div>
      </div>
    </el-dialog>
    
    <!-- 发起赛事表单 -->
    <el-dialog title="发起赛事" :visible.sync="showEventForm" width="600px">
      <el-form label-width="120px">
        <el-form-item label="赛事名称" required>
          <el-input placeholder="请输入赛事名称"></el-input>
        </el-form-item>
        <el-form-item label="赛事描述">
          <el-input type="textarea" placeholder="请输入赛事描述" rows="3"></el-input>
        </el-form-item>
        <el-form-item label="比赛模式" required>
          <el-select placeholder="请选择比赛模式">
            <el-option label="1V1" value="1v1"></el-option>
            <el-option label="2V2" value="2v2"></el-option>
            <el-option label="3V3" value="3v3"></el-option>
            <el-option label="4V4" value="4v4"></el-option>
            <el-option label="5V5" value="5v5"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="奖池金额">
          <el-input-number :min="0" :step="100" placeholder="请输入奖池金额"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        <el-form-item label="报名费">
          <el-input-number :min="0" :step="10" placeholder="请输入报名费"></el-input-number>
          <span style="margin-left: 10px;">元</span>
        </el-form-item>
        <el-form-item label="最大队伍数">
          <el-input-number :min="2" :max="64" :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="比赛时间" required>
          <el-date-picker type="datetime" placeholder="请选择比赛时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="赛事规则">
          <el-input type="textarea" placeholder="请输入赛事规则" rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEventForm = false">取消</el-button>
        <el-button type="primary" @click="showEventForm = false; $message.success('发起赛事成功，等待审核')">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 赛事详情 -->
    <el-dialog title="赛事详情" :visible.sync="showEventDetail" width="700px">
      <div v-if="currentEvent" class="event-detail">
        <h3>{{ currentEvent.title }}</h3>
        <div class="detail-info">
          <div class="info-item">
            <span class="label">赛事描述：</span>
            <span class="value">{{ currentEvent.description || '暂无描述' }}</span>
          </div>
          <div class="info-item">
            <span class="label">比赛模式：</span>
            <span class="value">{{ getGameModeLabel(currentEvent.gameMode) }}</span>
          </div>
          <div class="info-item">
            <span class="label">奖池：</span>
            <span class="value">{{ currentEvent.prizePool || 0 }}元</span>
          </div>
          <div class="info-item">
            <span class="label">报名费：</span>
            <span class="value">{{ currentEvent.registrationFee || 0 }}元</span>
          </div>
          <div class="info-item">
            <span class="label">最大队伍数：</span>
            <span class="value">{{ currentEvent.maxTeams }}</span>
          </div>
          <div class="info-item">
            <span class="label">已报名队伍：</span>
            <span class="value">{{ currentEvent.currentTeams || 0 }}</span>
          </div>
          <div class="info-item">
            <span class="label">比赛时间：</span>
            <span class="value">{{ formatDate(currentEvent.startTime) }}</span>
          </div>
          <div class="info-item">
            <span class="label">状态：</span>
            <span class="value">
              <el-tag :type="getEventStatusType(currentEvent.status)">
                {{ getEventStatusLabel(currentEvent.status) }}
              </el-tag>
            </span>
          </div>
          <div class="info-item">
            <span class="label">赛事规则：</span>
            <span class="value">{{ currentEvent.rules || '暂无规则' }}</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEventDetail = false">关闭</el-button>
        <el-button type="success" v-if="currentEvent && currentEvent.status === 0" @click="registerEvent(currentEvent)">报名参赛</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Broadcast',
  data() {
    return {
      activeTab: 'broadcast',
      broadcastList: [],
      eventList: [],
      showAddForm: false,
      showCrowdfundingForm: false,
      showDetail: false,
      showEventForm: false,
      showEventDetail: false,
      currentBroadcast: null,
      currentEvent: null,
      crowdfundingRecords: [],
      
      broadcastForm: {
        title: '',
        description: '',
        teamA: '',
        teamB: '',
        gameMode: '',
        matchType: 'match',
        needCrowdfunding: 0,
        targetAmount: 0,
        currentAmount: 0,
        crowdfundingStatus: 0,
        broadcastAmount: 0,
        status: 0
      },
      
      crowdfundingForm: {
        amount: 10
      },
      
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 50, message: '标题长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        teamA: [
          { required: true, message: '请输入A队选手', trigger: 'blur' }
        ],
        teamB: [
          { required: true, message: '请输入B队选手', trigger: 'blur' }
        ],
        gameMode: [
          { required: true, message: '请选择比赛模式', trigger: 'change' }
        ],
        broadcastAmount: [
          { required: true, message: '请输入点播金额', trigger: 'blur' }
        ],
        targetAmount: [
          { required: true, message: '请输入众筹目标金额', trigger: 'blur' }
        ]
      },
      
      crowdfundingRules: {
        amount: [
          { required: true, message: '请输入众筹金额', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadBroadcastList();
    this.loadEventList();
  },
  methods: {
    loadBroadcastList() {
      // 调用后端API获取点播列表
      this.$axios.get('/broadcast/list').then(res => {
        if (res.code === 200) {
          this.broadcastList = res.data.records;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(error => {
        console.error('获取点播列表失败:', error);
        this.$message.error('获取点播列表失败');
      });
    },
    
    getGameModeLabel(mode) {
      const modeMap = {
        '1v1': '1V1',
        '2v2': '2V2',
        '3v3': '3V3',
        '4v4': '4V4',
        '5v5': '5V5'
      };
      return modeMap[mode] || mode;
    },
    
    getCrowdfundingStatusLabel(status) {
      const statusMap = {
        0: '待审核',
        1: '进行中',
        2: '已完成',
        3: '已结束'
      };
      return statusMap[status] || '未知状态';
    },
    
    submitBroadcastForm() {
      this.$refs.broadcastFormRef.validate((valid) => {
        if (valid) {
          // 实际需要调用后端API提交表单
          this.$message.success('发起点播成功，等待审核');
          this.showAddForm = false;
          this.loadBroadcastList();
          this.resetBroadcastForm();
        }
      });
    },
    
    submitCrowdfunding() {
      this.$refs.crowdfundingFormRef.validate((valid) => {
        if (valid) {
          // 实际需要调用后端API提交众筹
          this.$message.success('参与众筹成功');
          this.showCrowdfundingForm = false;
          this.loadBroadcastList();
          this.resetCrowdfundingForm();
        }
      });
    },
    
    viewBroadcast(broadcast) {
      // 调用后端API获取点播详情
      this.$axios.get(`/broadcast/detail/${broadcast.id}`).then(res => {
        if (res.code === 200) {
          this.currentBroadcast = res.data;
          this.showDetail = true;
          // 加载众筹记录
          this.loadCrowdfundingRecords(broadcast.id);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(error => {
        console.error('获取点播详情失败:', error);
        this.$message.error('获取点播详情失败');
      });
    },
    
    loadCrowdfundingRecords(broadcastId) {
      // 调用后端API获取众筹记录
      this.$axios.get(`/broadcast/crowdfunding-records/${broadcastId}`).then(res => {
        if (res.code === 200) {
          this.crowdfundingRecords = res.data;
        } else {
          this.$message.error(res.msg);
        }
      }).catch(error => {
        console.error('获取众筹记录失败:', error);
        this.$message.error('获取众筹记录失败');
      });
    },
    
    openCrowdfundingForm(broadcast) {
      // 打开众筹表单前，先赋值currentBroadcast
      this.currentBroadcast = broadcast;
      this.showCrowdfundingForm = true;
    },
    
    submitBroadcastForm() {
      this.$refs.broadcastFormRef.validate((valid) => {
        if (valid) {
          // 安全设置发起人ID，避免访问undefined的属性
          this.broadcastForm.createUserId = this.$store.state.user?.id || 1;
          // 调用后端API提交表单
          this.$axios.post('/broadcast/create', this.broadcastForm).then(res => {
            if (res.code === 200) {
              this.$message.success('发起点播成功，等待审核');
              this.showAddForm = false;
              this.loadBroadcastList();
              this.resetBroadcastForm();
            } else {
              this.$message.error(res.msg || '发起点播失败');
            }
          }).catch(error => {
            console.error('发起点播失败:', error);
            this.$message.error('发起点播失败');
          });
        }
      });
    },
    
    submitCrowdfunding() {
      this.$refs.crowdfundingFormRef.validate((valid) => {
        if (valid) {
          // 调用后端API提交众筹
          const record = {
            broadcastId: this.currentBroadcast.id,
            userId: this.$store.state.user?.id || 1, // 安全访问用户ID，默认值为1
            amount: this.crowdfundingForm.amount
          };
          this.$axios.post('/broadcast/crowdfunding', record).then(res => {
            if (res.code === 200) {
              this.$message.success('参与众筹成功');
              this.showCrowdfundingForm = false;
              this.loadBroadcastList();
              this.resetCrowdfundingForm();
              // 更新当前点播的已筹金额
              if (this.currentBroadcast) {
                this.currentBroadcast.currentAmount += this.crowdfundingForm.amount;
              }
            } else {
              this.$message.error(res.msg || '参与众筹失败');
            }
          }).catch(error => {
            console.error('参与众筹失败:', error);
            this.$message.error('参与众筹失败');
          });
        }
      });
    },
    
    resetBroadcastForm() {
      this.$refs.broadcastFormRef.resetFields();
      this.broadcastForm.needCrowdfunding = 0;
      this.broadcastForm.targetAmount = 0;
      this.broadcastForm.matchType = 'match';
    },
    
    resetCrowdfundingForm() {
      this.$refs.crowdfundingFormRef.resetFields();
      this.crowdfundingForm.amount = 10;
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // ========== 赛事举办相关方法 ==========
    
    loadEventList() {
      // 调用后端API获取赛事列表
      this.$axios.get('/event/list').then(res => {
        if (res.code === 200) {
          this.eventList = res.data || [];
        } else {
          // 暂时使用模拟数据
          this.eventList = [];
        }
      }).catch(error => {
        console.error('获取赛事列表失败:', error);
        // 使用模拟数据
        this.eventList = [];
      });
    },
    
    getEventStatusType(status) {
      const typeMap = {
        0: 'info',      // 报名中
        1: 'warning',   // 进行中
        2: 'success',   // 已结束
        3: 'danger'     // 已取消
      };
      return typeMap[status] || 'info';
    },
    
    getEventStatusLabel(status) {
      const statusMap = {
        0: '报名中',
        1: '进行中',
        2: '已结束',
        3: '已取消'
      };
      return statusMap[status] || '未知';
    },
    
    viewEvent(event) {
      this.currentEvent = event;
      this.showEventDetail = true;
    },
    
    registerEvent(event) {
      this.$confirm('确定要报名参加此赛事吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        // 调用后端API报名参赛
        this.$message.success('报名成功，请等待赛事开始');
      }).catch(() => {
        this.$message.info('已取消报名');
      });
    }
  }
}
</script>

<style scoped>
.broadcast-container {
  padding: 20px 0;
}

.broadcast-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.add-btn {
  float: right;
}

.tab-header {
  margin-bottom: 15px;
  text-align: right;
}

.broadcast-list {
  margin-top: 20px;
}

.detail-info {
  margin: 20px 0;
}

.info-item {
  margin-bottom: 15px;
  display: flex;
}

.info-item .label {
  font-weight: bold;
  width: 100px;
  display: inline-block;
}

.info-item .value {
  flex: 1;
}

.crowdfunding-records {
  margin: 20px 0;
}

.video-player {
  margin: 20px 0;
}

.video-player video {
  margin-top: 10px;
}

.dialog-footer {
  text-align: right;
}
</style>